import { useEffect } from 'react';
import Head from 'next/head';
import Image from 'next/image';
import Link from 'next/link';
import AOS from 'aos';

export default function Home() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 40,
    });
  }, []);

  return (
    <>
      <Head>
        <title>ISABHEL</title>
        <meta
          name="description"
          content="Integrated satellite and ground-based monitoring platform for assessing bridge health across its lifetime."
        />
      </Head>
      <div className="min-h-screen bg-wave">
        {/* Content */}
        <div className="relative z-10 min-h-screen flex flex-col">
          {/* Header */}
          <header
            className="px-4 py-5 sm:p-10"
            data-aos="fade-down"
            data-aos-delay="100"
          >
            <div className="grid w-full grid-cols-[minmax(0,5.5rem)_1fr_minmax(0,5.5rem)] items-center gap-3 sm:grid-cols-[1fr_auto_1fr] sm:gap-0">
              <div className="justify-self-start">
                <Image
                  src="/icons/nhazca.png"
                  alt="NHAZCA logo"
                  width={160}
                  height={56}
                  priority
                  className="h-auto w-full max-w-22 drop-shadow-md sm:h-8 sm:w-auto sm:max-w-none"
                />
              </div>
              <div className="px-1 text-center sm:px-0">
                <h1 className="mt-1 text-[1.5rem] font-bold text-white text-shadow-sm text-shadow-black/70 sm:text-3xl">
                  ISABHEL
                </h1>
              </div>
              <div className="justify-self-end">
                <Image
                  src="/icons/esa-bw.png"
                  alt="ESA logo"
                  width={160}
                  height={56}
                  priority
                  className="h-auto w-full max-w-16 drop-shadow-md sm:h-8 sm:w-auto sm:max-w-none"
                />
              </div>
            </div>
          </header>

          {/* Main Content */}
          <main className="grow flex items-center justify-center px-4 pb-10 pt-4 sm:p-6">
            <div className="mx-auto max-w-3xl text-center space-y-6 sm:space-y-8">
              <h2
                className="text-4xl font-bold text-white text-shadow-xs text-shadow-black md:text-5xl"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                Integrated satellite and ground-based monitoring for bridge health lifetime assessment
              </h2>
              <p
                className="px-2 text-lg font-medium leading-relaxed text-white text-shadow-xs text-shadow-black sm:px-0 sm:text-xl"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                Advanced bridge monitoring and analysis platform for structural health assessment
              </p>
              <div
                className="flex flex-col gap-3 justify-center sm:flex-row sm:gap-4"
                data-aos="fade-up"
                data-aos-delay="400"
              >
                <Link
                  href="/dashboard"
                  className="w-full rounded-lg bg-slate-700 px-6 py-3 text-base font-medium text-white backdrop-blur-xl inset-shadow-sm inset-shadow-slate-500 transition-all duration-200 hover:scale-105 hover:bg-slate-800 sm:w-auto sm:px-8 sm:text-lg"
                >
                  <span className="flex items-center justify-center">
                    Go to Dashboard
                  </span>
                </Link>
                <Link
                  href="/login"
                  className="w-full rounded-lg bg-cyan-800 px-6 py-3 text-base font-medium text-white inset-shadow-sm inset-shadow-cyan-600 shadow-lg transition-all duration-200 hover:scale-105 hover:bg-cyan-900 hover:shadow-lg sm:w-auto sm:px-8 sm:text-lg"
                >
                  Sign In
                </Link>
              </div>
            </div>
          </main>

          {/* Footer */}
          <footer className="p-6" data-aos="fade-up" data-aos-delay="500">
            <div className="max-w-7xl mx-auto text-center text-white/70">
              <p>© 2024 ISABHEL. All rights reserved.</p>
            </div>
          </footer>
        </div>

        {/* Animated Particles or Shapes (Optional) */}
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          <div className="absolute top-20 left-10 w-20 h-20 bg-teal-500/20 rounded-full blur-xl
                    animate-pulse transform animate-float"></div>
          <div className="absolute bottom-20 right-10 w-32 h-32 bg-teal-400/20 rounded-full blur-xl
                    animate-pulse transform animate-float-delayed"></div>
        </div>
      </div>
    </>
  );
}

Home.useLayout = false;
